import { render, staticRenderFns } from "./MessageEntrance.vue?vue&type=template&id=4c26cfd0&scoped=true&"
import script from "./MessageEntrance.vue?vue&type=script&lang=js&"
export * from "./MessageEntrance.vue?vue&type=script&lang=js&"
import style0 from "./MessageEntrance.vue?vue&type=style&index=0&id=4c26cfd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c26cfd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c26cfd0')) {
      api.createRecord('4c26cfd0', component.options)
    } else {
      api.reload('4c26cfd0', component.options)
    }
    module.hot.accept("./MessageEntrance.vue?vue&type=template&id=4c26cfd0&scoped=true&", function () {
      api.rerender('4c26cfd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MessageAgentSub/MessageEntrance.vue"
export default component.exports